(function () {
  function init(root) {
    var line = root.querySelector('[data-ft-line]');
    var items = root.querySelectorAll('[data-ft-item]');
    if (!line || !items.length) return;

    var holdMs = parseInt(root.getAttribute('data-hold') || '1600', 10);
    var exitMs = parseInt(root.getAttribute('data-exit') || '350', 10);

    var texts = [];
    for (var i = 0; i < items.length; i++) {
      var t = (items[i].textContent || '').trim();
      if (t) texts.push(t);
    }
    if (!texts.length) return;

    var idx = 0, t1, t2;

    function show(txt) {
      clearTimeout(t1); clearTimeout(t2);

      line.classList.remove('is-exit');
      line.classList.remove('is-enter');

      line.textContent = txt;
      void line.offsetWidth;

      line.classList.add('is-enter');

      t1 = setTimeout(function () {
        line.classList.remove('is-enter');
        line.classList.add('is-exit');

        t2 = setTimeout(function () {
          idx = (idx + 1) % texts.length;
          show(texts[idx]);
        }, exitMs);
      }, holdMs);
    }

    show(texts[idx]);
  }

  function boot() {
    var roots = document.querySelectorAll('[data-ft-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
